import { render, staticRenderFns } from "./UmbrellaIcon.vue?vue&type=template&id=7e2d43d0&scoped=true&"
import script from "./UmbrellaIcon.vue?vue&type=script&lang=ts&"
export * from "./UmbrellaIcon.vue?vue&type=script&lang=ts&"
import style0 from "./UmbrellaIcon.vue?vue&type=style&index=0&id=7e2d43d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2d43d0",
  null
  
)

export default component.exports